import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { UI_FORM_IMPORTS } from '@program-suite/ui';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AdminSettingsStore } from '../../data/admin-settings.store';
import { AuthStore } from '@program-suite/data-auth';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'lib-fees',
  templateUrl: './fees.component.html',
  styleUrls: ['./fees.component.scss', '../admin-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, ReactiveFormsModule, MatCheckboxModule, ...UI_FORM_IMPORTS],
})
export class FeesComponent {
  adminSettingsStore = inject(AdminSettingsStore);
  authStore = inject(AuthStore);

  mgaFees = computed(() => {
    const mgaFees = this.adminSettingsStore.tenantFees?.()?.mgaFees || [];
    return mgaFees;
  });
  adhocFees = computed(() => {
    const adhocFees = this.adminSettingsStore.tenantFees?.()?.adhocFeeSchedules || [];
    return adhocFees;
  });
  agencyDefaultCommissions = computed(() => {
    const agencyCommissions = this.adminSettingsStore.tenantFees?.()?.agencyCommissions || [];
    return agencyCommissions;
  });

  constructor(private route: ActivatedRoute) {
    const tenantId = this.route.snapshot.queryParams['tenantId'];
    if (tenantId) {
      this.adminSettingsStore.getTenantFees(tenantId);
    } else {
      this.adminSettingsStore.getTenantFees();
    }
  }

  minZero(value: number | null): number {
    if (value === null) {
      return 0;
    }
    return value < 0 ? 0 : value;
  }
}
